import palette from '../palette';

export default {
  root: {
    '&$selected': {
      backgroundColor: palette.background.default
    },
    '&:hover': {
      backgroundColor: '#F9F9F9'
    }
  }
};
